export const newDetailCardImplementedTypes = new Set([
  'HOTEL',
  'ACCOMMODATION',
  'ACCOMMODATION_RENTAL',
  'AIRBNB',
  'ATTRACTION',
  'RESTAURANT_BAR',
  'EVENT',
  'THING_TO_DO',
  'EXPERIENCE',
])
